// Die Seiten des Medien-Moduls (docs/medien.md). lib/routes.ts hängt sie
// im Abschnitt Zuhause direkt nach dem Kalender ein (eine Zeile); ein
// eigener Bereich ist es nicht. internal/navcheck liest auch diese Datei.
//
// Alle drei Pfade zeigen dieselbe Seite (Medien.svelte); welche Ansicht
// gilt, liest sie aus ihrem Pfad: alle · nur Filme · nur Serien. Der Baum
// nestet Filme und Serien unter „Medien“ (Pfad-Präfix).

import type { RouteItem } from "../../lib/routes";

export const medienRouten: RouteItem[] = [
  {
    path: "/zuhause/medien",
    label: "Medien",
    component: () => import("./Medien.svelte"),
    hidden: true,
    aliases: ["Filme", "Serien", "Film", "Serie", "Kino", "Jellyfin", "Video", "Mediathek", "Weiterschauen"],
  },
  {
    path: "/zuhause/medien/filme",
    label: "Filme",
    component: () => import("./Medien.svelte"),
    hidden: true,
    aliases: ["Film", "Kino", "Spielfilm", "Movies"],
  },
  {
    path: "/zuhause/medien/serien",
    label: "Serien",
    component: () => import("./Medien.svelte"),
    hidden: true,
    aliases: ["Serie", "Staffel", "Folge", "Folgen", "Series"],
  },
];

/** Was die Suche zu den Seiten wissen soll (lib/routes.ts, routeIntents). */
export const medienAbsichten: Record<string, string> = {
  "/zuhause/medien": "Filme und Serien anschauen, Mediathek, Film suchen, weiterschauen wo ich aufgehört habe, was ist neu hinzugekommen, Ersatz für Jellyfin",
  "/zuhause/medien/filme": "alle Filme als Posterwand, Film suchen, nach Jahr oder Alphabet sortieren, Film abspielen",
  "/zuhause/medien/serien": "alle Serien als Posterwand, Folgen und Staffeln, nächste Folge abspielen, Serie suchen",
};
